import { FunctionComponent } from 'react';

import Header from 'components/layout/Header';
import { HeaderStyles, HeaderTextPositions } from 'components/layout/Header/types';
import LayoutContainer from 'components/layout/LayoutContainer/component';

import StyledComponent from './styles';
import { Props } from './types';


const PagePrivacyPolicySectionContent: FunctionComponent<Props> = ({ translations }) => {
    return (
        <StyledComponent className="page-privacy-policy-section-content">
            <LayoutContainer className="section-wrapper">
                <Header
                    isPrimaryTitle={true}
                    title={translations.title}
                    style={HeaderStyles.Form}
                    textPosition={HeaderTextPositions.Center}
                />
                <div
                    className="content"
                    dangerouslySetInnerHTML={{ __html: translations.policyContent }}
                />
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PagePrivacyPolicySectionContent;